import { render, staticRenderFns } from "./fadeDown.vue?vue&type=template&id=6a0268bb&scoped=true&"
import script from "./fadeDown.vue?vue&type=script&lang=js&"
export * from "./fadeDown.vue?vue&type=script&lang=js&"
import style0 from "./fadeDown.vue?vue&type=style&index=0&id=6a0268bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0268bb",
  null
  
)

component.options.__file = "fadeDown.vue"
export default component.exports